import { useState } from 'react'
/**
 * @export
 * @description fake loading for components
 * @param {number} time fake loading duration at milliseconds
 * @returns {boolean} return true or false
 * @example const { isLoading } = useLoading(500)
 */

export const useLoading = (time: number): { isLoading: boolean } => {
  const FAKE_LOADING_DURATION = time
  const [isLoading, setLoading] = useState(true)

  const timeout = setTimeout(() => {
    setLoading(false)

    if (!isLoading) {
      clearTimeout(timeout)
    }
  }, FAKE_LOADING_DURATION)

  return { isLoading }
}
